
import React from 'react';
// import { useLocation } from "react-router-dom";
import "./Footer.css";

const Footer = () => {
  // const location = useLocation();
  // console.log(location.pathname, ">>>>>>>>>>>>>>zxnjdfh>>>>>>");
  return (<div className="footerContent"><p>Copyright © 2013-2019 FryRight Inc.</p></div>);
};
export default Footer;



